import { BUTTON_CLICK } from '@amzn/carrierlogistics-commons/dist/constants/analytics';
import { DEVICE_WIDTHS } from '@amzn/carrierlogistics-commons/dist/constants/breakpoints';
import { recordCustomEventInCloudWatchRUM } from '@amzn/carrierlogistics-commons/dist/utils/cloudwatchRum';
import blueDarkTokens from '@amzn/meridian-tokens/theme/blue-dark';
import Responsive from '@amzn/meridian/responsive';
import Row from '@amzn/meridian/row';
import SideMenu, { SideMenuLink } from '@amzn/meridian/side-menu';
import Theme from '@amzn/meridian/theme';
import TransReportsCenterProvider from '@amzn/trans-reports-center-ui-assets/dist/TransReportsCenterProvider';
import useTransReportsCenterSideNavMenuItems from '@amzn/trans-reports-center-ui-assets/dist/hooks/useSideNavMenuItems';
import { noop } from 'lodash';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useHistory, useLocation, withRouter } from 'react-router-dom';
import SupportNavMenu from '../components/SideNavSupport';
import LpDropdown from '../components/molecules/LpDropdown';
import { SIDE_NAV_MENU_BUTTON } from '../constants/analytics';
import useSideNavItems from '../hooks/useSideNavItems';
import { isANonSignedInPage, isAuthorizedPage } from '../utils/authorizedPageUtils';
import LanguageToggleModule from './LanguageToggleModule';

const SideNavMenu = ({ isMenuOpened, onClose }) => {
  const { pathname = '' } = useLocation();
  const sideNavItems = useSideNavItems();
  const history = useHistory();
  const handleRouting = (item) => {
    history.push(item.link);
  };
  const [expandParentTab, setExpandParentTab] = useState(null);
  const {
    sideMenuNavItems: transReportsCenterSideNavMenuItems,
  } = useTransReportsCenterSideNavMenuItems();

  const isNonSignedInPage = isANonSignedInPage(pathname);

  const handleItemClick = (item) => {
    if (item.children) {
      setExpandParentTab(expandParentTab === item.link ? null : item.link);
    } else {
      handleRouting(item);
    }
    recordCustomEventInCloudWatchRUM(BUTTON_CLICK, {
      action_properties: {
        name: SIDE_NAV_MENU_BUTTON,
      },
      extra_properties: {
        name: item.link,
      },
    });
  };

  return (
    <Responsive
      query="min-width"
      props={{
        isSmallScreen: {
          default: true,
          [DEVICE_WIDTHS.DESKTOP]: false,
        },
      }}
    >
      {({ isSmallScreen }) => (
        <Theme tokens={blueDarkTokens}>
          <SideMenu
            open={isMenuOpened}
            closeLabel="Close"
            onClose={onClose}
            width="15rem"
          >
             {isSmallScreen && isAuthorizedPage(pathname) && (
              <SideMenuLink key="lp-dropdown" onClick={noop}>
                <LpDropdown />
              </SideMenuLink>
            )}
            {[...sideNavItems, ...transReportsCenterSideNavMenuItems].map(
              (item) => {
                if (item.isDisabled) return null;
                return (
                  <SideMenuLink
                    key={item.link}
                    selected={pathname.includes(item.link)}
                    open={expandParentTab === item.link}
                    onClick={() => handleItemClick(item)}
                    disabled={!item.isAuthorized}
                  >
                    <Row>
                      <Row>{item.label}</Row>
                    </Row>
                    {item.children
                      && item.childNodes.map((child) => (
                        <SideMenuLink
                          key={child.link}
                          selected={pathname.includes(child.link)}
                          onClick={() => {
                            handleRouting(child);
                          }}
                          disabled={!child.isAuthorized}
                        >
                          {child.label}
                        </SideMenuLink>
                      ))}
                  </SideMenuLink>
                );
              },
            )}
            {isSmallScreen && <LanguageToggleModule />}
            <SupportNavMenu />
          </SideMenu>
        </Theme>
      )}
    </Responsive>
  );
};
SideNavMenu.propTypes = {
  isMenuOpened: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default withRouter(TransReportsCenterProvider(SideNavMenu));
